








import Vue from 'vue';
export default Vue.extend({
  name: 'PageSidebar',
  props: {
    heading: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
  },
});
